module.exports = __webpack_public_path__ + "static/socialImage-f9101e8fc3342282f9a39cbe62cff1cb.jpg";